import React from 'react';

import ModelTypeConstants from 'constants/ModelTypeConstants';

import {getSharedSmartChipProps, SharedSmartChipProps} from './ChipUtil';
import SmartChip from './SmartChip';
import useSmartChipQuery, {SmartChipType} from './useSmartChipQuery';

export interface WorklistChipProps extends SharedSmartChipProps<SmartChipType.WORKLIST> {
  id: string;
}

export default function WorklistChip(props: WorklistChipProps): JSX.Element {
  const sharedSmartChipProps = getSharedSmartChipProps(props);
  const {id} = sharedSmartChipProps;

  const {item: worklist, isInaccessible} = useSmartChipQuery<SmartChipType.WORKLIST>({id});

  return (
    <SmartChip
      {...sharedSmartChipProps}
      icon={ModelTypeConstants.WORKLIST}
      item={worklist}
      onClick={() => {
        /* no-op */
      }}
      url={null}
      isInaccessible={isInaccessible}
    />
  );
}
